// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.HHpQ5PHk6swn9_Vq1XJh{flex-direction:column;gap:18px;display:flex}.O3V1n2iJMr4cXFyVQ7gw{justify-content:flex-end;gap:8px;margin-top:18px;display:flex}.ZnI3nB0LgQoKcHjlxV9x{align-items:center;gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `HHpQ5PHk6swn9_Vq1XJh`,
	"actions": `O3V1n2iJMr4cXFyVQ7gw`,
	"labelContent": `ZnI3nB0LgQoKcHjlxV9x`
};
export default ___CSS_LOADER_EXPORT___;
